var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-vip-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-vip-modal-content" }, [
            _c("div", { staticClass: "modal-section" }, [
              _c("div", { staticClass: "selection-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("stars")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("auto.selectVipStatus")))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vip-options" }, [
                  _c(
                    "div",
                    {
                      staticClass: "vip-card",
                      class: { selected: _vm.vipCustomer === true },
                      on: {
                        click: function ($event) {
                          _vm.vipCustomer = true
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-icon vip-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("star"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.$t("auto.vipCustomer"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("auto.selectedContactsWillBeMarkedAsVip")
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selection-indicator" }, [
                        _vm.vipCustomer === true
                          ? _c("i", { staticClass: "material-icons" }, [
                              _vm._v("check_circle"),
                            ])
                          : _c("i", { staticClass: "material-icons" }, [
                              _vm._v("radio_button_unchecked"),
                            ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "vip-card",
                      class: { selected: _vm.vipCustomer === false },
                      on: {
                        click: function ($event) {
                          _vm.vipCustomer = false
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-icon normal-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("person"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.$t("auto.normalCustomer"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-description" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "auto.vipStatusWillBeRemovedAndStandardPriority"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selection-indicator" }, [
                        _vm.vipCustomer === false
                          ? _c("i", { staticClass: "material-icons" }, [
                              _vm._v("check_circle"),
                            ])
                          : _c("i", { staticClass: "material-icons" }, [
                              _vm._v("radio_button_unchecked"),
                            ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v(_vm._s(_vm.$t("auto.cancel"))),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("done"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.applyStatus")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }